import React, { useEffect, useState } from "react";
import styles from '../ChatMessages/ChatMessages.module.sass'
import UserPhoto from "../../../components/UserPhoto";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import cn from 'classnames';
import { ChatContext } from "../../../contexts/ChatContext";
import { useContext } from "react";
import { UserContext } from "../../../contexts/UserContext";
import GameInjector from "../../Game/GameInjector";
import { GameContext } from "../../../contexts/GamesContext";
import { ConquerContext } from "../../../contexts/ConquerContext";
import CONFIG from "../../../../Core/CONFIG/CONFIG";

const ChatShare = ({ data, isOwnLastMessage }) => {

    const conquer = useContext( ConquerContext );
    const {show,hide} = useContext( GameContext );

    data = data.data && typeof data.data != 'string' ? data.data : data;
    const chatContext = useContext( ChatContext );
    const ownerAvatar = chatContext.avatars[data.avatarID];
    const [gameData, setGameData] = useState({});

    useEffect( () => {

        async function doWork(){
            let response = await conquer.Games.getData( data.metadata.gameKey );
            response.square = CONFIG.vars.PUBLIC_FULL_URL + '/' + response.square;
            setGameData( response );
        }
        doWork();

    }, []);

    return (
        <>
            <div className={styles.avatar}>
                { isOwnLastMessage && <UserPhoto data={ownerAvatar}/>}
            </div>
            <div className={styles.sharedContent && styles.content}>
                <button onClick={() => { show({gameKey: data.metadata.gameKey, clear: false}) }}>
                    <img className={styles.sharedImage} src={ gameData.square } alt="" />
                </button>
                <div className={styles.sharedText}>
                    <div> <span>{data.text || data.data}</span> </div>
                    <div className={styles.time}>{data.dateString}</div>
                </div>
            </div>
            
        </>
    );

};

export default ChatShare;
